import styled from 'styled-components';

export const Continer = styled.div `
    width: 85%;
    margin: auto;
    box-sizing: border-box;
    padding: 5px;

`

export const ProfileSkills = styled.div `
    padding: 50px 0;
    overflow: hidden;

`
export const ProfileSection = styled.div `
    width: 50%;
    float: left;

`

export const ProfileList = styled.ul `
    list-style: none;
`

export const ProfileItem = styled.li `
    margin-bottom: 8px;

`

export const PItemSpan = styled.span `
    display: inline-block;
    width: 100px;
    font-weight: bold;
`


export const Web = styled.span `
font-weight: normal;
    color: #eb5424;
`

export const SkillsSection = styled.div `
    width: 50%;
    float: left;
`
export const SkillsDesc = styled.p `
    font-size: 15px;
    color: #888;
    line-height: 1.5;
    margin-bottom: 10px;
`
export const Bar = styled.div `
    overflow: hidden;
    padding: 10px 0;
    margin-bottom: 5px;
`

export const SkillsTittle = styled.span `
    float: left;
`

export const Perc = styled.span `
    float: right;
    margin-right: 100px;
`

export const Parent  = styled.div `
    height: 2px;
    clear: both;
    background: #f8f8f8;
    position: relative;
    top: 5px;

`
export const ParentSpan = styled.span `
    background: #eb5424;
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    bottom: 0;
`
/*
export const SpanSpan1 = styled.span `
    width: 100%;
`
export const SpanSpan2 = styled.span `
    width: 90%;
`
export const SpanSpan3 = styled.span `
    width: 80%;
`
*/
export const TittlePAS = styled.h2 `
    font-size: 40px; 
    margin-bottom: 0px;
`
export const SpanPAS = styled.span `
    font-weight: normal;
`
